module.exports = __webpack_public_path__ + "img/CommunityServicesBG.404c41fb.jpg";